module.exports = __webpack_public_path__ + "static/img/1260_phase_function_Paper_Points.58fa76f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1260_phase_function_Paper_Points.png
// module id = 6wBj
// module chunks = 0